import api from '../../api/index.js'

const state = {

}

const getters = {
}

const actions = {
    // 获取评论列表
    getCommandCommentList({commit}, payload) { 
        return new Promise((resolve, reject) => {
            api.get('/CommandComment/GetCommandCommentList',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        })
    },
    // 发表评论
    addCommandComment({commit}, payload) { 
        return new Promise((resolve, reject) => {
            api.post('/CommandComment/AddCommandComment',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        })
    },

}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}
